/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    CoverAndBenefits: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.CoverAndBenefits',
        defaultMessage: 'Cover and benefits'
    },
    SagaSelect: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.SagaSelect',
        defaultMessage: 'Saga Select'
    },
    YourExistingCover: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.YourExistingCover',
        defaultMessage: '(your existing cover)'
    },
    SagaPlus: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.SagaPlus',
        defaultMessage: 'Saga Plus'
    },
    ThreeYearsFixedPrice: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.ThreeYearsFixedPrice',
        defaultMessage: '3-year fixed price'
    },
    Bullet1: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.Bullet1',
        defaultMessage: 'If nothing changes your price will remain the same for 3-years'
    },
    Bullet2: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.Bullet2',
        defaultMessage: 'It\'s the price that\'s fixed, not you - there is no cancellation fee'
    },
    TCApply: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.TCApply',
        defaultMessage: 'T&Cs apply'
    },
    Optional: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.Optional',
        defaultMessage: 'Optional'
    },
    Yes: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.Yes',
        defaultMessage: 'Yes'
    },
    No: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.No',
        defaultMessage: 'No'
    },
    UninsuredDriverCover: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.UninsuredDriverCover',
        defaultMessage: 'Uninsured driver cover '
    },
    UninsuredDriverInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.UninsuredDriverInfo',
        defaultMessage: '– if an uninsured driver hits your car, through no fault of yours, as long as you supply their vehicle registration and the accident details we\'ll refund any excess paid and your No Claim Discount won\'t be reduced.'
    },
    LegalProtection: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.LegalProtection',
        defaultMessage: 'Legal Protection'
    },
    LegalProtectionInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.LegalProtectionInfo',
        defaultMessage: '– we\'ll cover up to £100,000 of legal costs to recover uninsured losses after a non-fault accident in the UK as long as an independent legal representative believes you can win your case.'
    },
    KeyProtection: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.KeyProtection',
        defaultMessage: 'Key Protection'
    },
    KeyProtectionInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.KeyProtectionInfo',
        defaultMessage: '- we’ll cover up to £2,500 per claim and, with us, you even get up to £50 for wear and tear. You won’t have to pay an excess, your NCD won’t be affected, and we cover claims up to 60 days after the insured incident.'
    },
    OnwardTaxiTravel: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.OnwardTaxiTravel',
        defaultMessage: 'Onward taxi travel'
    },
    OnwardTaxiTravelInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.OnwardTaxiTravelInfo',
        defaultMessage: '– if the damage to your car means you can’t continue your journey after an accident in the UK, we’ll offer to arrange a taxi to take you to any necessary UK destinations.'
    },
    AccidentHealthcareCover: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.AccidentHealthcareCover',
        defaultMessage: 'Accident Healthcare cover'
    },
    AccidentHealthcareCoverInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.AccidentHealthcareCoverInfo',
        defaultMessage: '– we’ll provide you and your spouse/partner with eligible private medical treatment up to £1,000,000 if you’re injured in a road traffic accident in the UK.'
    },
    ProtectedNoClaimDiscount: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.ProtectedNoClaimDiscount',
        defaultMessage: 'Protected No Claim Discount'
    },
    ProtectedNoClaimDiscountInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.ProtectedNoClaimDiscountInfo',
        defaultMessage: '– if you have four or more years’ NCD, we’ll protect it against two fault claims in a three-year period.'
    },
    ClaimsPromise: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.ClaimsPromise',
        defaultMessage: 'Claims Promise'
    },
    ClaimsPromiseInfo: {
        id: 'cep.components.sgRenewalSpmUpgradeTable.ClaimsPromiseInfo',
        defaultMessage: '– while you are with us, your NCD won’t be affected by claims caused by theft, fire, storm, flood or animal damage, or if your vehicle is hit when parked.'
    }
});
